import React from 'react';
import { useParams } from 'react-router-dom';
import './AdminPages.css';

const Preview = () => {
  const { slug } = useParams();

  return (
    <div className="admin-page">
      <div className="container">
        <h1>Preview: {slug}</h1>
        <p>Preview unpublished changes before making them live.</p>
        <div className="card">
          <p>Display preview of unpublished content for the selected page.</p>
        </div>
      </div>
    </div>
  );
};

export default Preview;
